import reactSprinkle from './favorite-sprinkle';
import Favorite from './favorite';
import initApollo from './init-apollo';
import { SAVED_ITEMS_QUERY } from '@general/graphql/viewer.graph';

const client = initApollo();

// this is a quick cache for pages like /news-and-views/icsc-exchange
// where the items are loaded via ajax and we don't we to retrieve the items again
// This doesn't account for a user logging out between changing the dropdown,
// but seems like an edgecase
let cachedSaved;
const getCachedSaved = () => cachedSaved;
const setCacheSaved = data => {
    cachedSaved = data;
};

const getSaved = () =>
    client.query({
        query: SAVED_ITEMS_QUERY,
        variables: {},
    });

const initSprinkles = data => {
    reactSprinkle({
        WrappedComponent: Favorite,
        customHtmlTag: 'favorite',
        globalProps: { client },
        savedItems: data,
    });
};

const initFavorites = async () => {
    const elements = document.getElementsByTagName('favorite');
    if (elements.length === 0) {
        return;
    }

    if (getCachedSaved()) {
        initSprinkles(getCachedSaved());
        return;
    }

    try {
        const savedItems = await getSaved();
        setCacheSaved(savedItems.data);
        initSprinkles(savedItems.data);
    } catch (e) {
        initSprinkles();
    }
};

// this is attached to the window so it can be called in the main asset bundle
window.icscInitFavorites = initFavorites;
